import React, { useState, useRef, useEffect } from "react";
import "./WhatsAppBot.css";

function WhatsAppBot({ isOpen, setIsOpen }) {
    const [inputValue, setInputValue] = useState("");
    const [chat, setChat] = useState([
        { text: "👋 Welcome to AI Gurukul! How can I help you today? Click a question below to get answers instantly!", type: "bot" }
    ]);
    const chatEndRef = useRef(null);
    const questionsRef = useRef(null);
    const chatbotRef = useRef(null);

    // Expert Numbers
    // Expert Numbers (Restored to original config)
    const CONTACTS = [
        { phone: "919225584952", slot: "morning" },
        { phone: "919822217064", slot: "afternoon" },
        { phone: "919822219735", slot: "evening" }
    ];

    const getExpertNumber = () => {
        const hour = new Date().getHours();
        if (hour >= 6 && hour < 12) return CONTACTS[0].phone;
        if (hour >= 12 && hour < 18) return CONTACTS[1].phone;
        return CONTACTS[2].phone;
    };

    const FAQS = [
        { q: "Will this help in future studies?", a: "🎓 AI Udaan School\nYes. It builds strong logical thinking, creativity, and problem-solving, which helps in subjects like math, science, and future career choices.\n\n💼 AI Pragati - For the people of college\nYes. It helps you apply AI in business, research, and presentations, giving you an edge in academics and projects.\n\n⚙️ AI Shilp (Engineering)\nAbsolutely. It strengthens your technical foundation, project work, and research capability, helping in higher studies (MTech/MS/AI specialization)." },
        { q: "Is AI useful for exams or projects?", a: "🎓 AI Udaan\nYes. You can use AI for:\n• Better understanding concepts\n• Creating school projects\n• Generating ideas and presentations\n\n💼 AI Pragati\nYes. AI helps in:\n• Writing assignments\n• Creating reports & PPTs\n• Case study analysis\n\n⚙️ AI Shilp\nYes. AI is critical for:\n• Final year projects\n• Research work\n• Building real-world applications" },
        { q: "What will I learn in this workshop?", a: "🎓 AI Udaan\n• Basics of AI\n• Using AI tools\n• Creating mini projects (chatbot, posters, etc.)\n\n💼 AI Pragati\n• AI for business (marketing, finance, HR)\n• Productivity tools\n• Real business use cases\n\n⚙️ AI Shilp\n• ML, GenAI, Agentic AI\n• Python + AI development\n• Building & deploying AI systems" },
        { q: "Do I need coding knowledge?", a: "🎓 AI Udaan\n❌ No coding required\n\n💼 AI Pragati\n❌ No coding required\n\n⚙️ AI Shilp\nYes. Basic coding (Python preferred), but we guide from fundamentals" },
        { q: "Will there be practical examples?", a: "🎓 AI Udaan (school)\nYes – games, tools, mini projects\n\n💼 AI Pragati (college)\nYes – real business cases, reports, dashboards\n\n⚙️ AI Shilp (job)\nYes – coding, AI models, APIs, deployment\n\n👉 All programs are hands-on focused" },
        { q: "How will this help my career?", a: "🎓 AI Udaan (school)\n• Early exposure to future careers\n• Builds confidence and innovation mindset\n\n💼 AI Pragati (college)\n• Makes you AI-enabled professional\n• Improves placement opportunities\n\n⚙️ AI Shilp (job)\nPrepares you for roles like:\n• AI Engineer\n• Data Analyst\n• GenAI Developer" },
        { q: "Will I get a certificate?", a: "✅ Yes (for all programs)\n• Issued by The DataTech Labs\n• Industry-recognized\n• Useful for:\n  - Resume\n  - College portfolio\n  - Placements" },
        { q: "What is this AI workshop about?", a: "🎓 AI Udaan (School)\nLearning AI in a simple, fun, and practical way\n\n💼 AI Pragati (college)\nUsing AI to solve business problems and improve productivity\n\n⚙️ AI Shilp (job)\nBuilding real AI systems and applications" },
        { q: "What is Artificial Intelligence?", a: "Artificial Intelligence (AI) is the ability of machines to think, learn, and make decisions like humans.\n\nExamples:\n• Chatbots\n• Recommendation systems\n• Self-driving technology" },
        { q: "Where is AI used in daily life?", a: "AI is already everywhere:\n📱 Mobile apps (Google, Instagram)\n🎬 YouTube/Netflix recommendations\n🛒 Online shopping\n🗺️ Google Maps navigation\n🏦 Banking fraud detection" },
        { q: "Is AI difficult to learn?", a: "❌ No.\nWith the right guidance, AI is easy and interesting.\nOur programs simplify AI for every level" },
        { q: "Can students learn AI?", a: "Yes absolutely.\nStudents from school to postgraduate level can learn AI.\nPrograms are designed age-wise and level-wise" },
        { q: "Why is AI important for the future?", a: "AI will:\n• Transform every industry\n• Create new job opportunities\n• Automate repetitive work\n• Increase efficiency and innovation\n\n👉 AI is not optional anymore — it is essential" }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (chatbotRef.current && !chatbotRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [setIsOpen]);

    useEffect(() => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [chat, isOpen]);

    const handleFaqClick = (faq) => {
        setChat([
            ...chat,
            { text: faq.q, type: "user" },
            { text: faq.a, type: "bot" }
        ]);
    };

    const handleCustomSubmit = (e) => {
        e.preventDefault();
        const msg = inputValue.toLowerCase().trim();
        if (!msg) return;

        const userMsg = { text: inputValue, type: "user" };
        let botResponse = "That's a great question! I'm still learning, but you can connect with our experts below for a detailed answer! 👇";

        // GREETING LOGIC
        const greetings = ['hi', 'hello', 'hey', 'hii', 'hy'];
        if (greetings.includes(msg)) {
            const hour = new Date().getHours();
            let timeGreeting = "Good Evening";
            if (hour >= 5 && hour < 12) timeGreeting = "Good Morning";
            else if (hour >= 12 && hour < 18) timeGreeting = "Good Afternoon";

            botResponse = `👋 ${timeGreeting}! Welcome to AI Gurukul. How can I help you today? You can ask about our courses, certification, or future studies!`;
        } else {
            // FAQ Matching Logic
            // Split user message into words and find the best matching FAQ
            const userWords = msg.split(/\s+/).filter(w => w.length > 2);
            let bestMatch = null;
            let maxMatches = 0;

            FAQS.forEach(faq => {
                const faqText = (faq.q + " " + faq.a).toLowerCase();
                let matches = 0;
                userWords.forEach(word => {
                    if (faqText.includes(word)) matches++;
                });
                if (matches > maxMatches) {
                    maxMatches = matches;
                    bestMatch = faq;
                }
            });

            if (bestMatch && maxMatches > 0) {
                botResponse = bestMatch.a;
            }
        }

        setChat([
            ...chat,
            userMsg,
            { text: botResponse, type: "bot" }
        ]);
        setInputValue("");
    };

    const handleConnect = () => {
        const number = getExpertNumber();
        const message = encodeURIComponent("Hi, I have a question about AI Gurukul.");
        window.open(`https://wa.me/${number}?text=${message}`, '_blank');
    };

    return (
        <div className={`whatsapp-bot-wrapper ${isOpen ? 'open' : ''}`} ref={chatbotRef}>
            <div className="whatsapp-bot-container">
                <div className="whatsapp-bot-header">
                    <div className="bot-info">
                        <div className="bot-avatar">🤖</div>
                        <div>
                            <div className="bot-name">AI Gurukul Assistant</div>
                            <div className="bot-status">Online</div>
                        </div>
                    </div>
                    <button 
                        className="chatbot-close-btn" 
                        onClick={() => setIsOpen(false)}
                        aria-label="Close Chatbot"
                    >
                        ✕
                    </button>
                </div>

                <div className="whatsapp-chat-box">
                    {chat.map((msg, i) => (
                        <div key={i} className={`whatsapp-msg ${msg.type}`}>
                            {msg.text}
                        </div>
                    ))}
                    <div ref={chatEndRef} />
                </div>

                <div className="whatsapp-footer">
                    <div className="faq-scroll" ref={questionsRef}>
                        {FAQS.map((faq, i) => (
                            <button key={i} onClick={() => handleFaqClick(faq)} className="whatsapp-faq-btn">
                                {faq.q}
                            </button>
                        ))}
                    </div>


                    <button className="whatsapp-connect-btn" onClick={handleConnect}>
                        <span>Connect to Expert</span>
                        <span className="whatsapp-icon">💬</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WhatsAppBot;
